<template>
  <card-list
    title="Info Retur Penjualan"
    data-size="10"
    data-url="/api/v1/return/items"
    edit-route="/return/sales-edit"
    :data-headers="tHeaders"
  />
</template>
<script>
import CardList from "../../components/CardList";
export default {
  name: "CustomerList",
  components: {
    CardList,
  },
  data () {
    return {
      tHeaders: [
        { warranty_code: 'Kode Garansi', align: 'left' },
        { item_name: 'Nama Barang', align: 'left' },
        { return_type_label: 'Tipe Retur', align: 'left' },
        { qty: 'Qty', align: 'right' },
        { return_date: 'Tanggal Retur', align: 'left', date: 'date' },
        { return_reason: 'Alasan Retur', align: 'left' },
        { status: 'Status', align: 'left' },
      ]
    }
  }
}
</script>
